const base = (website) => {
  return ({
    email: website.root.email,
    location: website.root.location,
    phone: website.root.phone
  });
};

const butterfly = (website) => {
  return({
    ...base(website),
    title: website.root.contactTitle,
    paragraphs: [
      { text: website.root.contactAbout },
    ]
  });
};

export const ContactFactory = {
  getBase: base,
  getButterfly: butterfly,
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/factories/ContactFactory.js